<template>
  <v-dialog v-model="visible" persistent max-width="638">
    <v-card class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.changeOwnerDialogTitle`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          fab
          flat
          color="gray-6"
          @click.native="close"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-4 pt-0 pb-5">
        {{ $t(`${namespace}.changeOwnerDialogText`) }}
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer />
        <a
          href="#"
          class="text--normal accent--text mr-4"
          color="accent"
          flat
          round
          @click.prevent="cancel"
        >
          {{ $t('Common.cancel') }}
        </a>
        <v-btn
          round
          depressed
          color="accent"
          @click.native="submit"
        >
          {{ $t('Common.proceed') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ChangeOwnerDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      namespace: 'Components.CostCenterForm'
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },

    close () {
      this.$emit('close')
    },

    submit () {
      this.close()
      this.$emit('submit')
    }
  }
}
</script>
